import { Component, OnInit,Output,Input, EventEmitter,ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DatepickerComponent, DatepickerOptions } from 'ng2-datepicker';
import { FilterDetail } from 'src/app/model/lookup/FilterDetail'
import { UserService } from '../../service/user.service';
//import { CreateRequestDetailsModel } from 'src/app/model/CreateRequestDetailsModel';
@Component({
  selector: 'app-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.scss']
})
export class ReportFilterComponent extends BaseComponent implements OnInit {
  currentYear=new Date("YYYY");
   @Output() outputData = new EventEmitter<{reportFromDate:string,reportToDate:string, period: string, year: string,month: string,implementation: string, service: string,customer:string,serviceCategory:string,employee:string  }>(); // Emitting an object
   @Input() showServiceDropDown: boolean=false;
   @Input() showImplementationDropDown: boolean=false;
   @Input() showCategoryDropDown: boolean=false;
   @Input() showCustomerDropDown: boolean=false;
   @Input() showEmployeeDropDown: boolean=false;   
   @Input() reportName: string="";
   

  @ViewChild("fromDate", { static: false }) fromDate: DatepickerComponent
  @ViewChild("toDate", { static: false }) toDate: DatepickerComponent
  _fromDate:string="";
  _toDate:string="";
  _period:number;
  _year:string="";
  _month  :string="";
  userId: number = null;
  selectedFilters: FilterDetail = new FilterDetail();
  _selectedMonth=[];
  // modelDetails: CreateRequestDetailsModel = new CreateRequestDetailsModel();
  fromDatePickeroptions: DatepickerOptions = {
      placeholder:this.lang==="en"?'From Date':'من تاريخ', // this.appTranslateService.getTranslate("Date"), // placeholder in case date model is null | undefined, example: 'Please pick a date'
      format: 'dd MMM, yyyy', // date format to display in in
      formatTitle: 'dd MMM, yyyy',
      formatDays: 'EEEEE',
      //defaultDate:new Date
      
    };
  toDatePickeroptions: DatepickerOptions = {
      placeholder: this.lang==="en"?'To Date':'الى تاريخ',// this.appTranslateService.getTranslate("pleaseSelectToDate"), // placeholder in case date model is null | undefined, example: 'Please pick a date'
      format: 'dd MMM, yyyy', // date format to display in input
      formatTitle: 'dd MMM, yyyy',
      formatDays: 'EEEEE',
      //defaultDate:Date.now(),
  };

  
  clearFromDate() {
    this.fromDate.displayValue = null;
    this.fromDate.innerValue = new Date();
    this.selectedFilters.fromDate = null;
    this.selectedFilters.fromDateYear = null;
    this.selectedFilters.fromDateMonth = null;
    this.selectedFilters.fromDateDay = null;
  }

  clearToDate() {
    this.toDate.displayValue = null;
    this.toDate.innerValue = new Date();
    this.selectedFilters.toDate = null;
    this.selectedFilters.toDateYear = null;
    this.selectedFilters.toDateMonth = null;
    this.selectedFilters.toDateDay = null;
  }

  
  //#region ReportPeriod DropDown
  //placeHolderReportPeriod: string=this.appTranslateService.getTranslate("SelectPeriod");  
  selectedReportPeriod: string;
     reportPeriods = [{ id: 0, name: this.lang==="en"? "Yearly":"سنوي" },
        { id: 1, name:this.lang==="en"? "Monthly":"شهري" },
        { id: 2, name: this.lang==="en"?"Weekly":"أسبوعي" },
        { id: 3, name: this.lang==="en"?"Date Range" :"تحديد التاريخ"},
        ];
  //  reportPeriods = [
  //       { id: 0, name: this.appTranslateService.getTranslate("Yearly") },
  //       { id: 1, name: this.appTranslateService.getTranslate("Monthly") },
  //       { id: 2, name: this.appTranslateService.getTranslate("Weekly") },
  //       { id: 3, name: this.appTranslateService.getTranslate("Date Range") },
  //   ];

  //#endregion

  //#region Year DropDown                            
  //placeHolderYear: string=this.appTranslateService.getTranslate("SelectYear");

  selectedYear= [];
  years = [];  
  
  //#endregion

  //#region Month DropDown
  //placeHolderMonth: string=this.appTranslateService.getTranslate("SelectMonth");
  selectedMonth= [];
    months = [ 
        { id: 0, name:  this.lang==="en"?"All":"الكل" },
        { id: 1, name: this.lang==="en"?"January":"يناير" },
        { id: 2, name: this.lang==="en"?"February": 'فبراير'},
        { id: 3, name: this.lang==="en"?"March":'مارس' },
        { id: 4, name: this.lang==="en"?"April" : 'أبريل'},
        { id: 5, name: this.lang==="en"?"May":'مايو'},
        { id: 6, name: this.lang==="en"?"June":'يونيو' },
        { id: 7, name: this.lang==="en"?"July":'يوليو' },
        { id: 8, name: this.lang==="en"?"August":'أغسطس' },
        { id: 9, name: this.lang==="en"?"September":'سبتمبر' },
        { id: 10, name:this.lang==="en"?"October":'أكتوبر' },
        { id: 11, name: this.lang==="en"?"November":'نوفمبر'},
        { id: 12, name: this.lang==="en"?"December":'ديسمبر' },
      ];  
  
  //#endregion

  //#region Implantation DropDown                            
  //placeHolderImplantation : string=this.appTranslateService.getTranslate("selectImplantation");

  selectedImplantation= [];
  Implantations = [];  
  
  //#endregion

  //#region Service DropDown                            
  //placeHolderService : string=this.appTranslateService.getTranslate("selectService");

  selectedService= [];
  Services = [];  
  
  //#endregion

  //#region Category DropDown                            
 // placeHolderCategory : string=this.appTranslateService.getTranslate("Select Category");

  selectedCategory= [];
  Categories = [];  
  
  //#endregion

  //#region Customer DropDown 

  selectedCustomer= [];
  Customers = [];   

  //#endregion

  //#region Customer DropDown 

  selectedEmployee= [];
  Employees = [];   
   
  //#endregion
  constructor(private userService: UserService) {

    super();
   }

  ngOnInit(): void {
 
   
  console.log(this.reportPeriods);
    this.CreateYearDropDown();

    if(this.showServiceDropDown){
      this.CreateServiceDropDown();
    }

    if(this.showImplementationDropDown){
      this.CreateImplantationDropDown();
    }

    if(this.showCategoryDropDown){   
      this.CreateCategoryDropDown();
    }
    //this.AddData();

    if(this.showCustomerDropDown){   
      this.CreateCustomerDropDown();
    }
      if(this.showEmployeeDropDown){   
      this.CreateEmployeeDropDown();
    }
  
    

  }

    AddData()
    {
       

          if (this.selectedFilters.fromDate && this.selectedFilters.fromDate !== null) {
            this.selectedFilters.fromDateYear = this.selectedFilters.fromDate.getFullYear();
            this.selectedFilters.fromDateMonth = this.selectedFilters.fromDate.getMonth() + 1;
            this.selectedFilters.fromDateDay = this.selectedFilters.fromDate.getDate();
          } else {
            this.selectedFilters.fromDateYear = null;
            this.selectedFilters.fromDateMonth = null;
            this.selectedFilters.fromDateDay = null;
          }
      
          if (this.selectedFilters.toDate && this.selectedFilters.toDate !== null) {
            this.selectedFilters.toDateYear = this.selectedFilters.toDate.getFullYear();
            this.selectedFilters.toDateMonth = this.selectedFilters.toDate.getMonth() + 1;
            this.selectedFilters.toDateDay = this.selectedFilters.toDate.getDate();
          } else {
            this.selectedFilters.toDateYear = null;
            this.selectedFilters.toDateMonth = null;
            this.selectedFilters.toDateDay = null;
          }
      
          if(this.selectedFilters.fromDateYear !==null && this.selectedFilters.fromDateMonth !==null && this.selectedFilters.fromDateDay!==null)
          {
             this._fromDate=this.selectedFilters.fromDateYear+'/'+this.selectedFilters.fromDateMonth+'/'+this.selectedFilters.fromDateDay
          }
      
          if(this.selectedFilters.toDateYear !==null && this.selectedFilters.toDateMonth !==null && this.selectedFilters.toDateDay!==null)
          {    
             this._toDate=this.selectedFilters.toDateYear+'/'+this.selectedFilters.toDateMonth+'/'+this.selectedFilters.toDateDay
          }
          
          if(this.selectedYear.includes(0))
          {           
            for (let year = 2020; year <= new Date().getFullYear(); year++) { 
              this.selectedYear.push(year)             
            }
          }
          
          if(this.selectedMonth.includes(0))
          {
              this._selectedMonth=["1","2","3","4","5","6","7","8","9","10","11","12"];           
          }
          else
          {
            this._selectedMonth=this.selectedMonth;
          }

          if (this.Implantations.includes(0)) {
              this.selectedImplantation = [];
              this.Implantations.forEach(element => {
          if (element.id != 0) {
            this.selectedImplantation.push(element.id);
          }

          if(this.selectedCustomer.includes(0) && this.showCustomerDropDown===true)
          {
              this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("youMustSelectAtLeastOneCustomer"));
              return;
          }
          else
          {
            this.selectedCustomer=this.selectedMonth;
          }
          if(this.selectedCategory.includes(0)&& this.showCategoryDropDown===true){
            this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("youMustSelectAtLeastOneCustomer"));
          }
        });
    }
        this.outputData.emit({reportFromDate:this._fromDate,reportToDate:this._toDate,period:this.selectedReportPeriod, year: this.selectedYear.toString(), month: this._selectedMonth.toString(),implementation: this.selectedImplantation.toString(), service: this.selectedService.toString(), customer:this.selectedCustomer.toString(),serviceCategory:this.selectedCategory.toString(),employee:this.selectedEmployee.toString()});
         
    }
  

  CreateYearDropDown()
  {   
    this.years.push({ id: 0, name: this.lang==="en"?"All":"الكل" });
    for (let year = 2020,id=0; year <= new Date().getFullYear(); year++,id++) { 
      this.years.push({ id: year, name: year.toString() });
    }
  }
  CreateServiceDropDown()
  {   
     this.userService.GetAllSevice().subscribe(
      res => {

        if (res.successed) {        
           res.data;  
           this.Services.push({ id: 0, name: this.lang==="en"?"All":"الكل" });              
           res.data.forEach(element => {
             this.Services.push({ id: element.id, name: element.nameEn });    
          });
        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
          if (res.errorCode === "Data not found") {
            this.router.navigate(["/"])
          }
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
   
  }
  
  CreateImplantationDropDown()
  {   
     this.userService.GetAllImplementation().subscribe(
      res => {

        if (res.successed) {        
           res.data;  
           this.Implantations.push({ id: 0, name: this.lang==="en"?"All":"الكل" }); 
            
          res.data.forEach(element => {
             this.Implantations.push({ id: element.id, name: element.nameEn });    
          });

        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
          if (res.errorCode === "Data not found") {
            this.router.navigate(["/"])
          }
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
   
  }

  CreateCategoryDropDown()
  {
    this.userService.GetAllCategory().subscribe(
      res => {

        if (res.successed) {        
           res.data;  
           this.Categories.push({ id: 0, name: this.lang==="en"?"All":"الكل" }); 
            
          res.data.forEach(element => {
            
             this.Categories.push({ id: element.id, name: element.nameEn });    
          });

        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
          if (res.errorCode === "Data not found") {
            this.router.navigate(["/"])
          }
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
  }

  CreateCustomerDropDown()
  {
    this.userService.GetAllCustomer().subscribe(
      res => {

        if (res.successed) {        
           res.data;  
                      
          res.data.forEach(element => {            
             this.Customers.push({ id: element.id, name: element.firstName });    
          });
          //console.log(this.Customers);
        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
          if (res.errorCode === "Data not found") {
            this.router.navigate(["/"])
          }
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
  }

  CreateEmployeeDropDown()
  {
    var data:any;
    this.userService.GetAllEmployee().subscribe(
      res => {

        if (res.successed) {        
           res.data;  
          
            
          res.data.forEach(element => {            
             this.Employees.push({ id: element.id, name: element.firstName });    
          });
          //console.log(this.Customers);
        }
        else {
          this.toastrAlertService.errorToastr(res.errorMessage);
          if (res.errorCode === "Data not found") {
            this.router.navigate(["/"])
          }
        }
      },
      error => {
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )
  }
  SelectedPeriod()
  {
   
    
    // if(this.selectedReportPeriod=="3")
    // {
    //   this.showDateRange=true;
    // }
    // else
    // {
    //   this.showDateRange=false;
    // }
  }

}
